import { z } from 'zod';

export const storeSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const storeValidationSchema = storeSchema
  .optional()
  .refine((store) => !!store?.id, {
    message: 'Store must be selected',
  });

export type Store = z.infer<typeof storeSchema>;
